export default function notificationSection() {
  document.querySelectorAll('[sw-notification]').forEach((notification) => {
    const dateUpdated = notification.getAttribute('sw-notification')
    const notified = window.localStorage.getItem(`notified-${notification.id}`) === dateUpdated;

    if (!notified) {
      document.body.classList.add(`is-showing-${notification.id}`)
      const closeButton = notification.querySelector('.notification_close')

      if (closeButton !== null) {
        closeButton.addEventListener('click', () => {
          document.body.classList.remove(`is-showing-${notification.id}`)
          window.localStorage.setItem(`notified-${notification.id}`, dateUpdated)
        })
      }
    }
  })
}



// WEBPACK FOOTER //
// ./source/scripts/sections/notification.js